import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { DeliveryOrderDriver } from '../driver/delivery-order-driver';
import { DeliveryOrderLocation } from '../delivery-order-location';
import { DeliveryOrder } from '../delivery-order';
import { DeliveryOrderGroupTrackingSchema } from './delivery-order-group-tracking.schema';
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';

@DtoForceConstructor
export class DeliveryOrderGroupTracking {
    public drivers: DeliveryOrderDriver[];
    public locations: DeliveryOrderLocation[];
    public orders: DeliveryOrder[];

    @DtoImport(DeliveryOrderGroupTrackingSchema)
    static import(dto: Dto): any {}

    constructor(value?: {
        drivers: DeliveryOrderDriver[];
        locations: DeliveryOrderLocation[];
        orders: DeliveryOrder[];
    }) {
        if (value) {
            this.drivers = value.drivers;
            this.locations = value.locations;
            this.orders = value.orders;
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderGroupTrackingSchema,
        },
    ])
    export(type?: DtoType): any {}
}
